import React, { Suspense, lazy, useEffect, useMemo } from "react";
import CustomizedSnackbars from "./components/Snackbar";
import controls, { endCall, restoreCallAfterBackground } from "./components/controls";
import Loading from "./components/Loading";
import AudioPlayer from "./components/AudioPlayer";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import createFrecallTheme from "./components/FrecallTheme";
import useWakeLock from "./components/wakeLock";

const Callpage = lazy(() => import("./components/CallPage"));

function App() {
  useWakeLock(); // Activate the wake lock
  const getInitialMode = () => {
    const savedMode = localStorage.getItem("frecall-caller-theme-mode");
    return savedMode === "dark" ? "dark" : "light";
  };

  const [themeMode, setThemeMode] = React.useState(getInitialMode);
  const theme = React.useMemo(() => createFrecallTheme(themeMode), [themeMode]);
  const toggleThemeMode = () => {
    setThemeMode((prevMode) => {
      const nextMode = prevMode === "light" ? "dark" : "light";
      localStorage.setItem("frecall-caller-theme-mode", nextMode);
      return nextMode;
    });
  };

  const urlData = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const pathCallerId = decodeURIComponent(
      window.location.pathname.split("/").filter(Boolean)[0] || "",
    );
    return {
      userId: params.get("userId") || pathCallerId,
      roomId: params.get("roomId") || "",
    };
  }, []);

  useEffect(() => {
    controls.callerId = urlData.userId;
    controls.roomId = urlData.roomId;
    if (["id", "null"].includes(controls.callerId)) controls.callerId = null;
  }, [urlData]);

  useEffect(() => {
    const handleTabClose = event => {
      event.preventDefault();

      // console.log('beforeunload event triggered');
      endCall();
      return (event.returnValue =
        'Are you sure you want to exit?');
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);

  useEffect(() => {
    const resumeActiveCall = () => {
      if (document.visibilityState === "visible") {
        restoreCallAfterBackground();
      }
    };

    document.addEventListener("visibilitychange", resumeActiveCall);
    window.addEventListener("pageshow", resumeActiveCall);
    window.addEventListener("focus", resumeActiveCall);

    return () => {
      document.removeEventListener("visibilitychange", resumeActiveCall);
      window.removeEventListener("pageshow", resumeActiveCall);
      window.removeEventListener("focus", resumeActiveCall);
    };
  }, []);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div hidden><AudioPlayer/></div>
        <Loading/>
        <CustomizedSnackbars/>
        <Suspense fallback={null}>
          <Callpage themeMode={themeMode} toggleThemeMode={toggleThemeMode}/>
        </Suspense>
        {/* <Typography
            component="span"
            sx={{
              fontSize: '0.6rem',
              color: 'gray',
              marginLeft: '4px',
              position: 'relative',
              bottom: '-2px', // Adjusts the placement relative to the main text
            }}
          >
            v - 1.31
          </Typography> */}
      </ThemeProvider>
    </div>
  );
}

export default App;
